export const getUserTypeOptions = () => {

    const userTypeOptions = [
        { label: 'Existing school official', value: 99 },
        { label: 'Prospect school official', value: 98 },
        { label: 'Deposit customer', value: 97 }
      ];

    return userTypeOptions;
}